import { render } from "./FlowPanelBlockElementsList.vue?vue&type=template&id=5278d93d&scoped=true&ts=true"
import script from "./FlowPanelBlockElementsList.vue?vue&type=script&lang=ts"
export * from "./FlowPanelBlockElementsList.vue?vue&type=script&lang=ts"

import "./FlowPanelBlockElementsList.vue?vue&type=style&index=0&id=5278d93d&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5278d93d"]])

export default __exports__